import { CloseOutlined } from "@ant-design/icons";
import { Pause } from "react-feather";

import "./stylesAddNoteModal.css";
import { Input, Select } from "antd";
import { useState } from "react";

function AddNoteModal({ handleCancel, handleNotesChange }) {
  const [note, setNote] = useState("");

  const handleNoteChange = (e) => {
    setNote(e.target.value);
  };

  const handleClose = () => {
    handleCancel();
    setNote("");
  };

  return (
    <div className="suspend-modal-container">
      <div className="modal-header">
        <div className="modal-header-title">
          <h2 className="modal-title">New Note</h2>
        </div>
        <CloseOutlined onClick={handleClose} className="close-icon" />
      </div>

      <div className="divider" />

      <div className="modal-content">
        <div className="transaction-info-item">
          <Input.TextArea
            type="text"
            value={note}
            maxLength={255}
            rows={3}
            placeholder="Leave a comment"
            onChange={handleNoteChange}
          />
          <span className="max-length">
            {note.length}/255
          </span>
        </div>
      </div>

      <div className="divider" />
      <div className="modal-footer">
        <div className="buttons">
          <button className="cancel-button" onClick={handleClose}>
            Close
          </button>
          <button
            className="save-button"
            onClick={() => {
              handleNotesChange(note);
              handleClose();
            }}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddNoteModal;
